(($) => {
  $(document).ready(() => {

    const calcTopPadding = () => {
      $('body').css('paddingTop', $('#head-section').height())
    }

    const headerSetup = () => {
      const scroll = $(document).scrollTop();


      if (scroll >= 300) {
        $('body').addClass('collapsed');
      } else {
        $('body').removeClass('collapsed');
      }
    };

    $(document).on('load', () => {
      calcTopPadding()
      headerSetup()
    })

    $(window).on('resize', () => {
      calcTopPadding()
      headerSetup()
    })

    calcTopPadding()
    headerSetup()

    $(document).on('scroll', () => {
      calcTopPadding()
      headerSetup()
    })
  })
})(jQuery)
